var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUserFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.271 9.47139L17.75 13.8187V10.4657C17.75 9.5368 16.7689 8.9729 16.021 9.47139L9.5 13.8187V4.17857C9.5 3.52766 8.99633 3 8.375 3H3.125C2.50367 3 2 3.52766 2 4.17857V23.8214C2 24.4723 2.50367 25 3.125 25H24.875C25.4963 25 26 24.4723 26 23.8214V10.4657C26 9.53675 25.0189 8.9729 24.271 9.47139Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-fill.aa1d4028.svg";
export { ForwardRef as ReactComponent };